import { AppState } from './index';

export const selectCulture = (state: AppState) => state.main.culture;
